<template>
  <div>
    <b-card>
      <b-table
        :items="inventory"
        :fields="fields"
        responsive
        striped
        bordered
        show-empty
        empty-text="No inventory data found"
      >
        <!-- SL -->
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Product Name -->
        <template #cell(product_name)="data">
          {{ data.item.product_name }}
        </template>

        <!-- Quantity -->
        <template #cell(quantity)="data">
          {{ data.item.quantity }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from "@vue/composition-api";
import { BCard, BTable } from "bootstrap-vue";
import api from "@/services/api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { decrypt } from "@/utils/crypto";

export default {
  components: {
    BCard,
    BTable,
  },
  setup() {
    const inventory = ref([]);
    const fields = [
      { key: "sl", label: "Sl." },
      { key: "product_name", label: "Product Name" },
      { key: "quantity", label: "Quantity" },
      { key: "amount", label: "Amount" },
      { key: "discount", label: "Discount" },
      { key: "total", label: "Total Amount" },
    ];

    const internalInstance = getCurrentInstance();
    const showCustomLoader = () => internalInstance?.proxy?.$showCustomLoader();

    const fetchInventory = async () => {
      const loader = showCustomLoader();
      try {
        const userData = decrypt(localStorage.getItem("userData"));
        const username = userData?.username;
        if (!username) throw new Error("User not logged in");

        const res = await api.get(`/api/v1/customer/inventory-line/${username}/`);
        inventory.value = res.data || [];
      } catch (err) {
        internalInstance.proxy.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: err.message || "Failed to fetch inventory data",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        loader?.hide();
      }
    };

    return {
      inventory,
      fields,
      fetchInventory,
    };
  },
  mounted() {
    this.fetchInventory();
  },
};
</script>
